<template>
  <div class="common-text">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>通用设置</BreadcrumbItem>
          <BreadcrumbItem>文字分享模板</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">文字分享模板</div>
      </div>
    </div>
    <div class="header-switch">
      <div class="header-switch-text">分享设置信息</div>
      <Button type="primary" @click="save()">保存</Button>
    </div>

    <div class="common-text-content">
      <div style="min-height: 400px;margin-bottom:20px;">
        <Row :gutter="32">
          <Col span="6" class="w-20">
            <div class="text-list-one">
              <p class="title">分享展会</p>
              <p class="title-2">分享标题</p>
              <Input placeholder="空白即默认为展会名" style="margin-bottom:20px;" v-model="exTitle" />
              <p class="title-2">分享描述</p>
              <Input placeholder="请输入" :rows="4" type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" v-model="exDes" />
              <p class="title-3">可替换字段：【主办】【展会】【时间】【地点】【公司】【展位号】</p>
            </div>
          </Col>
          <Col span="6" class="w-20">
            <div class="text-list-one">
              <p class="title">分享展商</p>
              <p class="title-2">分享标题</p>
              <Input placeholder="空白即默认为展商名" style="margin-bottom:20px;" v-model="exhibitorTitle" />
              <p class="title-2">分享描述</p>
              <Input placeholder="请输入" :rows="4" type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" v-model="exhibitorDes" />
              <p class="title-3">可替换字段：【主办】【展会】【时间】【地点】【公司】【展位号】</p>
            </div>
          </Col>
          <Col span="6" class="w-20">
            <div class="text-list-one">
              <p class="title">分享展品</p>
              <p class="title-2">分享标题</p>
              <Input placeholder="空白即默认为展品名" style="margin-bottom:20px;" v-model="proTitle" />
              <p class="title-2">分享描述</p>
              <Input placeholder="请输入" :rows="4" type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" v-model="proDes" />
              <p class="title-3">可替换字段：【主办】【展会】【时间】【地点】【公司】【展位号】</p>
            </div>
          </Col>
          <Col span="6" class="w-20">
            <div class="text-list-one">
              <p class="title">分享供需</p>
              <p class="title-2">分享标题</p>
              <Input placeholder="空白即默认为展商名" style="margin-bottom:20px;" v-model="supplyTitle" />
              <p class="title-2">分享描述</p>
              <Input placeholder="请输入" :rows="4" type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" v-model="supplyDes" />
              <p class="title-3">可替换字段：【主办】【展会】【时间】【地点】【公司】【展位号】</p>
            </div>
          </Col>
          <Col span="6" class="w-20">
            <div class="text-list-one">
              <p class="title">分享活动</p>
              <p class="title-2">分享标题</p>
              <Input placeholder="空白即默认为活动名" style="margin-bottom:20px;" v-model="actTitle" />
              <p class="title-2">分享描述</p>
              <Input placeholder="请输入" :rows="4" type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" v-model="actDes" />
              <p class="title-3">可替换字段：【主办】【展会】【时间】【地点】【公司】【展位号】</p>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "host-common-text",
  data() {
    return {
      exTitle: "",
      exDes: "",
      exhibitorTitle: "",
      exhibitorDes: "",
      proTitle: "",
      proDes: "",
      supplyTitle: "",
      supplyDes: "",
      actTitle: "",
      actDes: "",
    }
  },
  methods: {
    init() {

    },
    save() {
      let req = {

      }
      console.log(req);
    }
  },
  created() {
  },
}
</script>

<style lang="scss" scoped>
.common-text {
  .header-switch {
    display: flex;
    align-items: center;
    padding: 0 25px 18px 35px;
    background: #fff;
    &-text {
      flex: 1;
      font-size: 14px;
      color: #808080;
    }
  }
  &-content {
    padding: 25px;
    color: #333;
    .w-20 {
      .text-list-one {
        border: solid 1px #dddddd;
        background-color: #fff;
        padding: 20px;
        margin-bottom: 32px;
      }
      .title {
        text-align: center;
        margin-bottom: 10px;
      }
      .title-2 {
        margin-bottom: 10px;
      }
      .title-3 {
        width: 80%;
        font-size: 12px;
        color: #bfbfbf;
        margin-top: 5px;
      }
    }
  }
}
</style>